import { BACKEND_ROUTES } from "../../backendRoutes";
import { PAGINATION } from "../../constants";
import useSWR from "swr";

export const useCompanies = () =>
    useSWR(
        `${BACKEND_ROUTES.COMPANY}?sort=name&limit=${PAGINATION.COMPANY.LIMIT.MAX}`
    );
